import React, { createContext, useContext, useState, useEffect } from "react"
import scrollTo from "gatsby-plugin-smoothscroll"

const OrderContext = createContext()

function OrderProvider({ children }) {
  const [is_loaded, setLoaded] = useState(false)
  const [res_error, serResError] = useState(null)
  const [show_form, handleShowForm] = useState(false)
  const [step, setStep] = useState(1)
  const checkValidation = data => Object.keys(data).length === 0

  useEffect(() => {
    if (is_loaded) {
      scrollTo("#order_form")
    }
  }, [step]) //eslint-disable-line
  useEffect(() => {
    setLoaded(true)
  }, [])

  return (
    <OrderContext.Provider
      value={{
        step,
        setStep,
        checkValidation,
        show_form,
        handleShowForm,
        scrollTo,
        res_error,
        serResError,
      }}
    >
      {children}
    </OrderContext.Provider>
  )
}

const useOrder = () => useContext(OrderContext)
export { OrderContext, useOrder }
export default OrderProvider
